export const teacherFields = [
  'user',
  'username',
  'status',
  'subjectArea',
  'description',
];
